export default {
    name: 'Nimi',
    tel: 'puhelin',
    save: 'Tallentaa',
    confirm: 'vahvistaa',
    cancel: 'Peruuttaa',
    delete: 'poistaa',
    complete: 'Viedä loppuun',
    loading: 'Ladataan...',
    telEmpty: 'Täytä puhelinnumero',
    nameEmpty: 'täytä nimesi',
    nameInvalid: 'Lisää voimassa oleva nimi',
    confirmDelete: 'Haluatko varmasti poistaa',
    telInvalid: 'Anna oikea puhelinnumero',
    vanCalendar: {
        end: 'loppu',
        start: 'alkaa',
        title: 'otsikko',
        confirm: 'vahvistaa',
        startEnd: 'alku loppu',
        weekdays: ['Päivä', 'Yksi', 'Kaksi', 'Kolme', 'Neljä', 'Viisi', 'Kuusi'],
    },
    vanCascader: {
        select: 'Valitse',
    },
    vanContactCard: {
        addText: 'Lisää yhteystieto',
    },
    vanContactList: {
        addText: 'uusi kontakti',
    },
    vanPagination: {
        prev: 'Edellinen sivu',
        next: 'seuraava sivu',
    },
    vanPullRefresh: {
        pulling: 'Päivitä vetämällä...',
        loosing: 'vapauta päivitä...',
    },
    vanSubmitBar: {
        label: 'kaikki:',
    },
    vanCoupon: {
        unlimited: 'ei käyttörajoituksia',
    },
    vanCouponCell: {
        title: 'kuponki',
        tips: 'Ei saatavilla',
    },
    vanCouponList: {
        empty: 'ei kuponkia',
        exchange: 'vaihto',
        close: 'ei kuponkia',
        enable: 'käyttökelpoinen',
        disabled: 'Ei saatavilla',
        placeholder: 'Anna tarjouskoodi',
    },
    vanAddressEdit: {
        area: 'alueella',
        postal: 'postinumero',
        areaEmpty: 'valitse alue',
        addressEmpty: 'Täytä tarkka osoite',
        postalEmpty: 'Virheellinen postinumeron muoto',
        defaultAddress: 'Aseta oletustoimitusosoitteeksi',
        telPlaceholder: 'Vastaanottajan matkapuhelinnumero',
        namePlaceholder: 'Vastaanottajan nimi',
        areaPlaceholder: 'Valitse maakunta/kaupunki/alue',
    },
    vanAddressEditDetail: {
        label: 'osoite',
        placeholder: 'Katunumero, kerroksen huoneen numero jne.',
    },
    vanAddressList: {
        add: 'lisää osoite',
    },
};
